module.exports = {
  ABOUT_FIELD_CARD: "ABOUT_FIELD_CARD",
  RELATED_MODULE_CARD: "RELATED_MODULE_CARD",
  LAYOUT_CARD: "LAYOUT_CARD"
};
